import { useQuery } from '@tanstack/react-query';
import { fetchTles } from '@/lib/satellites';

/** TLE sets for tracked satellite groups (stations + brightest), refreshed every 30 min. */
export function useTles(enabled: boolean) {
  return useQuery({
    queryKey: ['tles'],
    queryFn: ({ signal }) => fetchTles(signal),
    enabled,
    staleTime: 30 * 60_000,
    retry: 2,
  });
}
